import './TeamPage.css';

class TeamPage {
  constructor(container) {
    this.container = container;

    // Image paths for Grant (normcore first as default)
    this.grantImages = [
      '/assets/grant-norm-core.png',
      '/assets/grant_cyberpunk.png',
      '/assets/grant_anime.png',
      '/assets/grant_80s_cyborg.png',
      '/assets/grant_hologram.png',
      '/assets/grant_pixel.png'
    ];

    // Currently selected image index
    this.selectedGrantImageIndex = 0;

    // Accordion state (default expanded)
    this.isCollaboratorsOpen = true;

    // Fun view / Basic view toggle (fun view is the default)
    this.currentView = 'fun';
    this.bubbles = null;
    this.funContainer = null;
    this.animationFrame = null;
    this.handleResize = this.handleResize.bind(this);

    // Collaborators data
    this.collaborators = [
      { name: 'Alexandra Attard-Manche', url: 'https://www.linkedin.com/in/alex-attard-manche/' },
      { name: 'Anders Ramsay', url: 'https://www.linkedin.com/in/andersramsay/' },
      { name: 'Andrew Shearer', url: 'https://www.linkedin.com/in/ajshearer/' },
      { name: 'Ax Ali', url: 'https://www.linkedin.com/in/theaxali/' },
      { name: 'Brian Kalma', url: 'https://www.linkedin.com/in/briankalma/' },
      { name: 'Charlie Charboneau', url: 'https://www.linkedin.com/in/charliecharboneau/' },
      { name: 'Chieh Huang', url: 'https://www.linkedin.com/in/chiehhuang/' },
      { name: 'Chloe Chou', url: 'https://www.linkedin.com/in/chloechoudesign/' },
      { name: 'Cory Dunton', url: 'https://www.linkedin.com/in/corydunton/' },
      { name: 'David Friedman', url: 'https://www.linkedin.com/in/uhnw/' },
      { name: 'John Cannon', url: 'https://www.linkedin.com/in/njohncannon/' },
      { name: 'Jonathan Stanley', url: 'https://www.instagram.com/p/DRAC8x4kQK9/' },
      { name: 'Josh Gunning', url: 'https://www.linkedin.com/in/joshgunning/' },
      { name: 'Marc Geraldez', url: 'https://www.linkedin.com/in/marc-geraldez/' },
      { name: 'Matthew Rosenberg', url: 'https://www.linkedin.com/in/matthewer/' },
      { name: 'Michia Rohrssen', url: 'https://www.linkedin.com/in/askmichia/' },
      { name: 'Pieter Morgan', url: 'https://www.linkedin.com/in/pietermorgan/' },
      { name: 'Robinson Greig', url: 'https://www.linkedin.com/in/robinsongreig/' },
      { name: 'Sarah Wang', url: 'https://www.linkedin.com/in/sarah-wang-69734055/' },
      { name: 'Sunil Gowda', url: 'https://www.linkedin.com/in/sunilgowda/' },
      { name: 'Will Johnson', url: 'https://www.linkedin.com/in/will-johnson-1435962/' },
    ];
  }
  
  /**
   * Render the team page
   */
  render() {
    this.container.innerHTML = `
      <div class="team-page">
        <div class="team-view-controls">
          <div class="team-view-toggle" role="tablist" aria-label="Team page view">
            <button type="button" class="team-view-toggle-btn ${this.currentView === 'fun' ? 'active' : ''}" data-view="fun" role="tab" aria-selected="${this.currentView === 'fun'}">Fun view</button>
            <button type="button" class="team-view-toggle-btn ${this.currentView === 'basic' ? 'active' : ''}" data-view="basic" role="tab" aria-selected="${this.currentView === 'basic'}">Basic view</button>
          </div>
          <div class="team-fun-legend" id="team-fun-legend" style="display: ${this.currentView === 'fun' ? 'flex' : 'none'};">
            <span class="team-legend-item"><span class="team-legend-swatch team-legend-swatch--founder"></span>Founder</span>
            <span class="team-legend-item"><span class="team-legend-swatch team-legend-swatch--collab"></span>Co-creators &amp; advisors</span>
          </div>
          <button type="button" class="team-mixitup-btn" id="team-mixitup-btn" style="display: ${this.currentView === 'fun' ? 'inline-flex' : 'none'};">Mix it up</button>
        </div>

        <div class="team-basic-view" id="team-basic-view" style="display: ${this.currentView === 'basic' ? 'block' : 'none'};">
        <table class="team-table">
          <tr>
            <th class="label-col"></th>
            <th data-person="grant"><a href="https://www.linkedin.com/in/grant-demeter-a90865116/" target="_blank" class="team-name-link">grant-demeter.li</a></th>
          </tr>
          <tr>
            <td class="table-label label-col">Looks like:</td>
            <td class="image-cell" data-person="grant">
              <div class="profile-image-container">
                <img src="${this.grantImages[this.selectedGrantImageIndex]}" alt="Grant Demeter" class="main-profile-image" id="grant-main-image">
                <div class="thumbnail-container">
                  ${this.grantImages.map((img, index) => `
                    <img src="${img}" alt="Grant Demeter ${index + 1}"
                         class="thumbnail-image ${index === this.selectedGrantImageIndex ? 'selected' : ''}"
                         data-person="grant" data-index="${index}">
                  `).join('')}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="table-label label-col">Does:</td>
            <td data-person="grant">Founder and Managing Partner</td>
          </tr>
          <tr>
            <td class="table-label label-col">Did:</td>
            <td data-person="grant">
              2x founder/co-founder (Morning Brew, OA)<br>
              7x creator/co-creator (see our <a href="/file/apps/creations.app" class="team-inline-link">apps</a>)<br>
              17x startup investor (Hallow, Quince, Music.ai, Volley, ++)
            </td>
          </tr>
          <tr>
            <td class="table-label label-col">Received:</td>
            <td data-person="grant">Harvard MBA<br>Forbes' "Best Mustache in Tech" 2021 - 2025</td>
          </tr>
          <tr>
            <td class="table-label label-col">Is giving:</td>
            <td data-person="grant">Nice guy from the midwest</td>
          </tr>
          <tr>
            <td class="table-label label-col">Is:</td>
            <td data-person="grant">✝</td>
          </tr>
        </table>

        <div class="team-accordion">
          <button class="team-accordion-header" id="collaborators-accordion-toggle">
            <span class="team-accordion-icon">${this.isCollaboratorsOpen ? '▾' : '▸'}</span>
            <span class="team-accordion-title">our_co-creators_and_advisors</span>
          </button>
          <div class="team-accordion-body ${this.isCollaboratorsOpen ? 'open' : ''}" id="collaborators-accordion-body">
            <ul class="collaborators-list">
              ${this.collaborators.map(person => `
                <li><a href="${person.url}" target="_blank" class="collaborator-link">${person.name}</a></li>
              `).join('')}
            </ul>
          </div>
        </div>
        </div>

        <div class="team-fun-view" id="team-fun-view" style="display: ${this.currentView === 'fun' ? 'block' : 'none'};"></div>
      </div>
    `;

    this.setupEventListeners();
    this.initFunView();

    return this;
  }
  
  /**
   * Set up event listeners for the thumbnail images and accordion
   */
  setupEventListeners() {
    // Fun view / Basic view toggle
    const toggleButtons = this.container.querySelectorAll('.team-view-toggle-btn');
    toggleButtons.forEach(btn => {
      btn.addEventListener('click', () => this.switchView(btn.dataset.view));
    });

    // Mix it up button
    const mixItUpBtn = this.container.querySelector('#team-mixitup-btn');
    if (mixItUpBtn) {
      mixItUpBtn.addEventListener('click', () => this.mixItUp());
    }

    window.addEventListener('resize', this.handleResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleResize);
    }

    // Collaborators accordion toggle
    const accordionToggle = this.container.querySelector('#collaborators-accordion-toggle');
    const accordionBody = this.container.querySelector('#collaborators-accordion-body');
    const accordionIcon = this.container.querySelector('.team-accordion-icon');

    if (accordionToggle) {
      accordionToggle.addEventListener('click', () => {
        this.isCollaboratorsOpen = !this.isCollaboratorsOpen;
        accordionBody.classList.toggle('open', this.isCollaboratorsOpen);
        accordionIcon.textContent = this.isCollaboratorsOpen ? '▾' : '▸';
      });
    }

    // Thumbnail image selection
    const thumbnails = this.container.querySelectorAll('.thumbnail-image');

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        const index = parseInt(e.target.dataset.index, 10);

        this.selectedGrantImageIndex = index;
        // Update main image
        const mainImage = this.container.querySelector('#grant-main-image');
        mainImage.src = this.grantImages[index];

        // Update thumbnail selection
        const grantThumbnails = this.container.querySelectorAll('.thumbnail-image[data-person="grant"]');
        grantThumbnails.forEach((thumb, i) => {
          if (i === index) {
            thumb.classList.add('selected');
          } else {
            thumb.classList.remove('selected');
          }
        });
      });
    });
  }

  /**
   * Fun view: bouncing name bubbles for Grant + all collaborators
   */
  getBubbleSize() {
    return window.innerWidth <= 600 ? 52 : 92;
  }

  /**
   * Shrink a bubble's font just for that bubble until every word fits
   * without breaking mid-word — names can still wrap onto a new line at a
   * space or hyphen, they just never split a single word across lines.
   */
  fitBubbleText(el) {
    const minFontSize = 6.5;
    let size = parseFloat(getComputedStyle(el).fontSize);
    el.style.fontSize = `${size}px`;

    let guard = 0;
    while (el.scrollWidth > el.clientWidth + 1 && size > minFontSize && guard < 40) {
      size -= 0.5;
      el.style.fontSize = `${size}px`;
      guard++;
    }
  }

  /**
   * A bubble never stops moving, and on touch devices a native click is
   * cancelled by the browser if the element shifts under the finger between
   * touchstart and touchend — which, for a bouncing bubble, is constantly.
   * Track the gesture ourselves and fire on pointerup instead of relying on
   * click synthesis; mouse/pen keep using the native click listener.
   */
  bindBubbleTap(el, action) {
    let tracking = false;
    let startX = 0;
    let startY = 0;
    let startTime = 0;

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'touch') return;
      tracking = true;
      startX = e.clientX;
      startY = e.clientY;
      startTime = Date.now();
    });

    el.addEventListener('pointerup', (e) => {
      if (e.pointerType !== 'touch' || !tracking) return;
      tracking = false;
      const dist = Math.hypot(e.clientX - startX, e.clientY - startY);
      if (dist < 20 && Date.now() - startTime < 800) {
        e.preventDefault();
        action();
      }
    });

    el.addEventListener('pointercancel', () => {
      tracking = false;
    });
  }

  /**
   * Size the arena to whatever's actually visible above the fold of its
   * scrollable ancestor (not a blind vh guess), so nothing renders clipped
   * behind the terminal panel or off-screen on short mobile viewports.
   */
  fitArenaToViewport(el, { min = 320, max = 560 } = {}) {
    let ancestor = el.parentElement;
    while (ancestor) {
      const overflowY = getComputedStyle(ancestor).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') break;
      ancestor = ancestor.parentElement;
    }
    if (!ancestor) return;

    const ancestorRect = ancestor.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    const availableBelow = ancestorRect.bottom - elRect.top - 12;

    el.style.height = `${Math.max(min, Math.min(max, availableBelow))}px`;
  }

  initFunView() {
    const container = this.container.querySelector('#team-fun-view');
    if (!container) return;
    this.funContainer = container;

    // render() runs before this.container is attached to the document (the
    // caller appends it into the tab system right after), so anything that
    // depends on real layout — measuring the scrollable ancestor, or the
    // container's own width/height — has to wait for that attach to land.
    requestAnimationFrame(() => this.setupFunViewGeometry(container));
  }

  setupFunViewGeometry(container) {
    if (!container.isConnected) return;
    this.fitArenaToViewport(container);

    const people = [
      { name: 'Grant Demeter', isFounder: true },
      ...this.collaborators.map(c => ({ name: c.name, url: c.url, isFounder: false })),
    ];

    const size = this.getBubbleSize();

    container.innerHTML = people.map((p, i) => (
      p.isFounder
        ? `<button type="button" class="team-bubble team-bubble--founder" data-index="${i}" style="width:${size}px;height:${size}px;" aria-label="${p.name} — switch to basic view"><span>${p.name}</span></button>`
        : `<a href="${p.url}" target="_blank" rel="noopener noreferrer" class="team-bubble team-bubble--collab" data-index="${i}" style="width:${size}px;height:${size}px;">${p.name}</a>`
    )).join('');

    const bubbleEls = Array.from(container.querySelectorAll('.team-bubble'));
    bubbleEls.forEach(el => this.fitBubbleText(el));
    const width = container.clientWidth || 600;
    const height = container.clientHeight || 420;
    const r = size / 2;

    this.bubbles = bubbleEls.map(el => {
      const x = r + Math.random() * Math.max(1, width - size);
      const y = r + Math.random() * Math.max(1, height - size);
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.6 + Math.random() * 0.6;
      return { el, x, y, vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed, r };
    });

    this.applyBubblePositions();

    const grantBubble = container.querySelector('.team-bubble--founder');
    if (grantBubble) {
      grantBubble.addEventListener('click', () => this.switchView('basic'));
      this.bindBubbleTap(grantBubble, () => this.switchView('basic'));
    }

    bubbleEls.forEach(el => {
      if (el.tagName === 'A') {
        const url = el.getAttribute('href');
        this.bindBubbleTap(el, () => window.open(url, '_blank', 'noopener,noreferrer'));
      }
    });

    if (this.currentView === 'fun') {
      this.startAnimation();
    }
  }

  switchView(view) {
    if (this.currentView === view) return;
    this.currentView = view;

    const basicEl = this.container.querySelector('#team-basic-view');
    const funEl = this.container.querySelector('#team-fun-view');
    const legendEl = this.container.querySelector('#team-fun-legend');
    const mixItUpBtn = this.container.querySelector('#team-mixitup-btn');
    const toggleButtons = this.container.querySelectorAll('.team-view-toggle-btn');

    toggleButtons.forEach(btn => {
      const isActive = btn.dataset.view === view;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', String(isActive));
    });

    if (view === 'fun') {
      if (basicEl) basicEl.style.display = 'none';
      if (funEl) funEl.style.display = 'block';
      if (legendEl) legendEl.style.display = 'flex';
      if (mixItUpBtn) mixItUpBtn.style.display = 'inline-flex';
      if (funEl) this.fitArenaToViewport(funEl);
      this.startAnimation();
    } else {
      if (basicEl) basicEl.style.display = 'block';
      if (funEl) funEl.style.display = 'none';
      if (legendEl) legendEl.style.display = 'none';
      if (mixItUpBtn) mixItUpBtn.style.display = 'none';
      this.stopAnimation();
    }
  }

  mixItUp() {
    if (!this.bubbles || !this.funContainer) return;
    const width = this.funContainer.clientWidth;
    const height = this.funContainer.clientHeight;

    this.bubbles.forEach(b => {
      b.x = b.r + Math.random() * Math.max(1, width - b.r * 2);
      b.y = b.r + Math.random() * Math.max(1, height - b.r * 2);
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.6 + Math.random() * 0.6;
      b.vx = Math.cos(angle) * speed;
      b.vy = Math.sin(angle) * speed;
    });
  }

  startAnimation() {
    this.stopAnimation();
    const step = () => {
      // Guard against a leaked loop if the tab/component was removed
      if (!this.funContainer || !this.funContainer.isConnected) {
        this.animationFrame = null;
        return;
      }
      this.updatePhysics();
      this.applyBubblePositions();
      this.animationFrame = requestAnimationFrame(step);
    };
    this.animationFrame = requestAnimationFrame(step);
  }

  stopAnimation() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
  }

  updatePhysics() {
    if (!this.bubbles || !this.funContainer) return;
    const width = this.funContainer.clientWidth;
    const height = this.funContainer.clientHeight;
    const bubbles = this.bubbles;

    bubbles.forEach(b => {
      b.x += b.vx;
      b.y += b.vy;

      if (b.x - b.r < 0) {
        b.x = b.r;
        b.vx = Math.abs(b.vx);
      } else if (b.x + b.r > width) {
        b.x = width - b.r;
        b.vx = -Math.abs(b.vx);
      }

      if (b.y - b.r < 0) {
        b.y = b.r;
        b.vy = Math.abs(b.vy);
      } else if (b.y + b.r > height) {
        b.y = height - b.r;
        b.vy = -Math.abs(b.vy);
      }
    });

    // Pairwise collisions (equal-mass elastic bounce)
    for (let i = 0; i < bubbles.length; i++) {
      for (let j = i + 1; j < bubbles.length; j++) {
        const a = bubbles[i];
        const b = bubbles[j];
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const dist = Math.sqrt(dx * dx + dy * dy) || 0.0001;
        const minDist = a.r + b.r;

        if (dist < minDist) {
          const overlap = (minDist - dist) / 2;
          const nx = dx / dist;
          const ny = dy / dist;

          a.x -= nx * overlap;
          a.y -= ny * overlap;
          b.x += nx * overlap;
          b.y += ny * overlap;

          const avn = a.vx * nx + a.vy * ny;
          const bvn = b.vx * nx + b.vy * ny;
          const diff = bvn - avn;

          a.vx += diff * nx;
          a.vy += diff * ny;
          b.vx -= diff * nx;
          b.vy -= diff * ny;
        }
      }
    }
  }

  applyBubblePositions() {
    this.bubbles.forEach(b => {
      b.el.style.transform = `translate(${(b.x - b.r).toFixed(1)}px, ${(b.y - b.r).toFixed(1)}px)`;
    });
  }

  handleResize() {
    if (!this.funContainer || !this.bubbles) return;
    this.fitArenaToViewport(this.funContainer);
    const width = this.funContainer.clientWidth;
    const height = this.funContainer.clientHeight;

    this.bubbles.forEach(b => {
      b.x = Math.min(Math.max(b.x, b.r), Math.max(b.r, width - b.r));
      b.y = Math.min(Math.max(b.y, b.r), Math.max(b.r, height - b.r));
    });

    if (this.currentView !== 'fun') {
      this.applyBubblePositions();
    }
  }
}

export default TeamPage;
